import { createContext, useContext } from 'react';
import { StockType } from 'models/stock.model';

export enum KitchenRequestActionType {
  REQUEST = 'REQUEST',
  RETURN = 'RETURN',
  WASTAGE = 'WASTAGE'
}
export type IKitchenRequest = {
  name: string;
  id: string;
  quantity: string;
  measurement: string;
};
export type KitchenInventoryStockContextType = {
  requests: IKitchenRequest[];
  setRequests: (requests: IKitchenRequest[]) => void;
  isPreview: boolean;
  setIsPreview: (isPreview: boolean) => void;
  selectedRequests: IKitchenRequest[];
  actionType: KitchenRequestActionType | null;
  setActionType: (action: KitchenRequestActionType | null) => void;
  vendorsArray: {
    name: string;
    price: string;
    id: string;
  }[];
  scrollIndex: number | null;
  setScrollIndex: (index: number | null) => void;
  stocksToEdit: StockType[];
  setStocksToEdit: (stocks: StockType[]) => void;
  stockToRecordWastage: StockType | null;
  setStockToRecordWastage: (stocks: StockType | null) => void;
};

export const KitchenInventoryStockContext = createContext({} as KitchenInventoryStockContextType);
const useKitchenInventoryStockContext = () => {
  const context = useContext(KitchenInventoryStockContext);
  return context;
};

export default useKitchenInventoryStockContext;
